import Header from '../../Header'
import * as styled from '../../style/main.style'
import Navbar from '../../Navbar'
import { useTranslation } from 'react-i18next'
import { Typography } from '@mui/material'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import TableCustom from '../../../../component/table/tableCustom'
import TableRowCommon from '../../../../component/table/TableRowCommon'
import { motion } from 'framer-motion'
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';
import { useState } from 'react'


let mockData = [
    {
        id: 1,
        rank: 1,
        report: "สรุปผลสำเร็จของการดำเนินงานในภาพรวม",
        path: "/auth/report/operational-achievements/report"
    },
]


const ReportShowingOperational = () => {
    const { t } = useTranslation();
    const navigate: NavigateFunction = useNavigate();

    const [page, setPage] = useState<number>(1);
    const [pageLimit, setPageLimit] = useState<number>(5);
    const [totalPage, setTotalPage] = useState<number>(2);

    const headCells = [
        {
            id: "RANK", disablePadding: false, width: 100, align: 'center', label: "ลำดับ"
        },
        {
            id: "PROJECT", disablePadding: false, align: "center", width: 800, label: "รายงาน"
        },
        {
            id: "STATUS", disablePadding: false, class: true, width: 100, align: "left", label: ""
        },
    ];


    const renderData = (objData: any, no: any) => {
        no = page * pageLimit - pageLimit + no + 1
        const { id, rank, report, path } =
            objData;

        const objRenderData = {
            key: id,
            id: no,
            obj: objData,
            columns: [
                { option: "TEXT", align: "center", label: rank },
                {
                    option: "TEXT",
                    align: "left",
                    label: report || "-",
                },
                {
                    option: "COMPONENT",
                    align: "right",
                    class: true,
                    component: (
                        <div className='text-left h-full w-full flex justify-end'>
                            <button onClick={() => navigate(path)} className='flex gap-x-3'>
                                <RemoveRedEyeOutlinedIcon className='text-base_disable cursor-pointer' />
                                <Typography>{t("BUTTON.VIEW")}</Typography>
                            </button>
                        </div >
                    ),
                },
            ],
        };
        return <TableRowCommon
            {...objRenderData}
        />;
    };


    return (
        <styled.ContainerHome>
            <Navbar />
            <styled.MainContainer>
                <Header />
                <styled.Content>
                    <motion.div
                        initial={{ x: 100 }}
                        animate={{ x: 0 }}
                        transition={{ ease: "backInOut", stiffness: 100 }}
                        className='w-full h-auto'>
                        <section>
                            <Typography className='text-primary' variant='h4'>
                                {"รายงานการแสดงผลสัมฤทธิ์การดำเนินงาน"}
                            </Typography>
                        </section>
                        <section className='w-full mt-3'>
                            <TableCustom
                                tableFixedWidth
                                tableMinWidth={1000}
                                customScroll
                                page={page}
                                pageLimit={pageLimit}
                                sortBy=""
                                sortType="ASC"
                                headCells={headCells}
                                rowCount={totalPage}
                                rowsData={mockData && mockData.map((data: any, i: any) => {
                                    return renderData(data, i)
                                })}
                                onSort={() => { }}
                                setPageLimit={(value: number) => setPageLimit(value)}
                                setPage={(value: number) => setPage(value)}
                                hidePagination
                            />
                        </section>
                    </motion.div>
                </styled.Content>
            </styled.MainContainer>

        </styled.ContainerHome>
    )
}

export default ReportShowingOperational
